import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { G4MetadataEdit } from "./edit";
import { G4MetadataNew } from "./new";
import { G4MetadataTable } from "./table";

export default function G4Positions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<G4MetadataEdit />} />
      <Route index element={<G4MetadataTable />} />
      <Route path="new" element={<G4MetadataNew />} />
    </Routes>
  );
}
